export default () => 'Terms of Service – Conjugr8'
